import * as serviceContext from '../services/serviceContext';
import { BASE_URL_M_ADMIN } from '../config';


let options = {};
let headers = new Headers();
const token = sessionStorage.getItem('token');

headers.append('content-type', 'application/json')
headers.append('Authorization', `${token}`);

options.headers = headers;
options.redirect = 'follow';

export async function getServiceWatchList() {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/ServiceMaster`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getLicenceAndWhiteLabelList() {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/ServiceMaster/list`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function getAllServiceIISAndWindows(opid) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/ServiceMaster/GetServiceList?operatorId=${opid}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function startService(service, opid) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/ServiceMaster/start/IIS/${service}?operatorId=${opid}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function stopService(service, opid) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/ServiceMaster/stop/IIS/${service}?operatorId=${opid}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}

export async function restartService(service, opid) {
    try {
        const response = await serviceContext.get(`${BASE_URL_M_ADMIN}madmin/ServiceMaster/restart/IIS/${service}?operatorId=${opid}`, null, options);
        const res = response.json();
        return res;
    } catch (error) {
        return error;
    }
}